import React from 'react';

// @ts-ignore
const AuthContext = React.createContext();

export default AuthContext;
